<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
import { buildMetaInfo } from './seo-meta'

export default {
  // 全站的 title / description / canonical / og / hreflang 都在这里统一生成，
  // 数据源是 src/seo.js。各页面组件不需要再各自声明 metaInfo。
  metaInfo() {
    // 价格方案从 i18n 取，SoftwareApplication 的 offers 要用
    const plans = this.$t('index.price.plans')
    return buildMetaInfo(this.$route.path, plans)
  }
}
</script>

<style lang="scss">
/**
 * 图片的 width/height 属性只用来给浏览器提供宽高比（避免加载时的布局跳动），
 * 不能让它决定实际高度。
 *
 * 只写了 width 的 CSS（比如 style="width: 1024px" 或某个 class）配上 height 属性时，
 * 高度会被属性值接管，图片就会被拉伸 —— /photoshop 和 /sketch 的首图就是这么变形的。
 * 加上 height: auto 之后，宽高比提示保留，实际高度仍由宽度按比例推导。
 *
 * 选择器只命中同时带两个属性的图片，即本次为防 CLS 补过尺寸的那些；
 * 只写 height（如导航栏 logo）的图片不受影响。
 */
img[width][height] {
  height: auto;
}

/**
 * hero 区块都带着 d-table（display:table），但全站没有任何 d-table-cell 与之配套 ——
 * 这是主题模板留下的、没人用的空壳。
 *
 * 它的害处只在窄屏显现：table 盒子不能窄于内容的 min-content 宽度，而 hero 里那几张
 * 定宽大图（例如 /photoshop 的 style="width:1024px; margin-left:-600px"）会把 min-content
 * 推到视口以外 —— 390px 视口下 /photoshop 被撑到 454px、/mobile 被撑到 830px。
 * body 上又有 overflow-x:hidden，超出的部分被静默裁掉，于是 h1 和正文在手机上被切断。
 *
 * 换成 block 后区块宽度回到视口宽度，文字正常换行；大图照旧溢出并被 body 裁切，
 * 出血的视觉效果不变。
 */
section.d-table {
  display: block !important;
}
</style>
